// Mantém em sync com worker/src/lib/types.ts e schema Airtable real.
export type Tipo = 'Cliente externo' | 'Unidade Apex' | 'Time Research';
export type CategoriaSolicitante = 'Cliente pagante' | 'Research Comercial' | 'Apex Interno';
export type StatusContrato = 'Vigente' | 'Renovação em curso' | 'Pausado' | 'Encerrado';
export type StatusDemanda =
  | 'Triagem' | 'Em produção' | 'Em revisão' | 'Aguardando aprovação'
  | 'Publicada' | 'Arquivada' | 'Cancelada';
export type Prioridade = 'Crítica' | 'Alta' | 'Média' | 'Baixa';
export type Origem = 'Externo (contratual)' | 'Apex (UN)' | 'Research (interno)';
export type TipoEntrega = 'producao' | 'checklist' | 'comercial';
export type TipoEvento =
  | 'proprietario' | 'patrocinado' | 'setorial' | 'interno' | 'institucional' | 'feriado'
  // Calendário 2026 (SharePoint) — importado em 03/07/2026
  | 'comercial' | 'terceiros' | 'mining_show' | 'experiencia';
export type CategoriaDemanda = 'tipo_a' | 'tipo_b';
/** v2 — frente do Conteúdo. Digital → Valentina/Agnes; TV → Fernanda Batista. */
export type Canal = 'digital' | 'tv';

export interface SubItemTipoB {
  solicitanteId: string;
  solicitanteNome?: string;
  status: 'pendente' | 'em_producao' | 'concluido';
  observacao?: string;
}

export interface CustomChecklistItem {
  id: string;
  titulo: string;
  etapa: string;
  responsavelId?: string;
  prazo?: string;
  areaId?: string;
  concluido: boolean;
}

export type SubEtapa =
  | 'Briefing inicial' | 'Pauta' | 'Pernas / marcação'
  | 'Agendamento' | 'Captação' | 'Roteiro' | 'Edição'
  | 'Revisão técnica' | 'Revisão editorial'
  | 'Cliente aprovando' | 'Ajustes finais'
  | 'Publicado';
export type CotaFamilia = 'Conecta Folha Business' | 'BRM - BUY' | 'Setorial' | 'Pesquisa';
export type CotaHierarquia = 'Básica' | 'Intermediária' | 'Premium';
export type Papel = 'Coordenação' | 'Diretoria' | 'Executor' | 'Comercial' | 'Cliente';

export interface Solicitante {
  id: string;
  nome: string;
  tipo: Tipo;
  familiaSubtipo?: string;
  setor?: string;
  status: 'Ativo' | 'Inativo';
  categoria?: CategoriaSolicitante;
}

export type SubtipoSetorial =
  | 'Mundo Business' | 'Agro Business'
  | 'Data Business Varejo' | 'Data Business Health' | 'Data Business Educação'
  | 'Data Business Logística' | 'Data Business Stone Cachoeiro' | 'Data Business Indústria'
  | 'Data Business Real Estate' | 'Data Business Tech Conference'
  | 'Fórum Econômico';

export type AreaForum = 'Research' | 'Gestão de Recursos' | 'Advisory' | 'Investment Banking';

export type SubtipoBRM =
  | 'BRM Brasília' | 'BRM SP' | 'BRM NY'
  | 'BUY ES' | 'BUY SP' | 'BUY SC' | 'BUY RS' | 'BUY PR' | 'BUY PT';

export interface Contrato {
  id: string;
  identificador: string;
  solicitanteId: string;
  solicitanteNome?: string;
  cotaId?: string;
  cotaNome?: string;
  cotaFamilia?: CotaFamilia;
  cotaHierarquia?: CotaHierarquia;
  subtipoSetorial?: SubtipoSetorial[];
  areaForum?: AreaForum;
  subtipoBRM?: SubtipoBRM;
  vigenciaInicio?: string;
  vigenciaFim?: string;
  valorMensal: number;
  status: StatusContrato;
}

export interface Demanda {
  id: string;
  titulo: string;
  solicitanteId: string;
  solicitanteNome?: string;
  origem: Origem;
  /** @deprecated legado — usar contratosIds (mantido até a migração Supabase) */
  contratoId?: string;
  /** S1 multi-cota — link "Contratos" (fallback para "Contrato" antigo) */
  contratosIds?: string[];
  /** S1 — "Clientes distribuição" (Solicitantes que recebem a entrega) */
  clientesIds?: string[];
  distribuicaoConfirmada?: boolean;
  faseEvento?: 'pre' | 'durante' | 'pos';
  tipoDemanda?: 'execucao' | 'card_mae' | 'verificacao_mac';
  /** JSON: DistribuicaoCredito[] — crédito por contrato (decisão 4.b) */
  distribuicaoCreditos?: string;
  produtoId?: string;
  /** Áreas donas (executam a peça). v2: consolidadas — sem Design/Dados. */
  areasIds: string[];
  areasNomes?: string[];
  /** v2 — áreas de apoio (participam, mas não são donas). */
  areasApoioIds?: string[];
  areasApoioNomes?: string[];
  /** v2 — Canal do material de conteúdo/vídeo; aciona coordenadores (Digital/TV). */
  canal?: Canal;
  coordenadorId?: string;
  executorId?: string;
  respBriefingIds?: string[];
  respProducaoIds?: string[];
  respRevisaoIds?: string[];
  respAprovacaoIds?: string[];
  /** v2 — pessoas colaboradoras em cards avulsos (criados manualmente/ad-hoc). */
  colaboradoresIds?: string[];
  /** v2 — episódio do Mundo Business vinculado (matéria/chamada/Fatos). */
  episodioId?: string;
  /** v2 — Fatos Relevantes que deve gerar reel para o Instagram. */
  reelFatos?: boolean;
  subEtapa?: SubEtapa;
  requerAprovacaoCliente?: boolean;
  status: StatusDemanda;
  prioridade: Prioridade;
  prazoSla?: string;
  dataPublicacao?: string;
  mesReferencia?: string;
  pauta?: string;
  briefing?: string;
  linkFinal?: string;
  comentarios?: string;
  tipoProduto?: string;
  tipoEntrega?: TipoEntrega;
  categoriaDemanda?: CategoriaDemanda;
  eventoId?: string;
  subItemsTipoB?: string;           // JSON: SubItemTipoB[]
  customChecklist?: string;         // JSON: CustomChecklistItem[]
  checklistProgresso?: string;
  checklistResponsaveis?: string;   // JSON: { itemId: [pessoaId, ...] }
  metricas?: {
    views?: number;
    engajamento?: number;
    ultimaSync?: string;
  };
}

/** S1 — status de crédito por contrato numa entrega multi-cota (decisão 4.b). */
export interface DistribuicaoCredito {
  contratoId: string;
  status: 'aguardando' | 'confirmado';
  confirmadoEm?: string;
  confirmadoPor?: string;
}

export interface Cota {
  id: string;
  nome: string;
  familia: CotaFamilia;
  hierarquia: CotaHierarquia;
  valorMensalSugerido: number;
}

export interface Pessoa {
  id: string;
  nome: string;
  papel: Papel;
  email?: string;
  areasIds: string[];
  capacidadeSemanal?: number;
  ativo: boolean;
  solicitanteIds?: string[];
  telefone?: string;
  avatarUrl?: string;
  usuario?: string;
  senhaTemporaria?: boolean;
}

export interface Area {
  id: string;
  nome: string;
}

export interface AuthenticatedUser {
  email: string;
  nome: string;
  papel: Papel;
  pessoaId?: string;
  solicitanteId?: string;
  avatarUrl?: string;
  telefone?: string;
  canVerValores?: boolean;
}

export interface DashboardVisaoGeral {
  mrr: number;
  contratosVigentes: number;
  contratosTotal: number;
  demandasTotal: number;
  porStatus: Record<string, number>;
  topClientes: { id: string; nome: string; volume: number }[];
  porArea: Record<string, number>;
  porFamilia: Record<string, number>;
  porOrigem: Record<string, number>;
}

// UI: nomes amigaveis (Airtable mantem labels originais)
const STATUS_DISPLAY: Record<StatusDemanda, string> = {
  'Triagem': 'Briefing',
  'Em produção': 'Em produção',
  'Em revisão': 'Em revisão',
  'Aguardando aprovação': 'Aguardando aprovação',
  'Publicada': 'Finalizado',
  'Arquivada': 'Arquivada',
  'Cancelada': 'Cancelada',
};
export function displayStatus(s: StatusDemanda): string {
  return STATUS_DISPLAY[s] ?? s;
}

export interface ItemKitCota {
  id: string;
  item: string;
  cotaIds: string[];
  produtoIds: string[];
  quantidade?: number;
  periodicidade?: 'Mensal' | 'Bimestral' | 'Trimestral' | 'Por evento' | 'Por ano' | 'Exclusiva (sob demanda)';
  entregaExclusiva?: boolean;
  observacoes?: string;
  /** S4 — consolidação de kit */
  consolidado?: boolean;
  grupoConsolidacao?: string;
  modoGeracao?: 'auto' | 'manual';
}

export type StatusEvento = 'Planejado' | 'Confirmado' | 'Realizado' | 'Cancelado';
export type FamiliaEvento = 'Conecta Folha Business' | 'BRM - BUY' | 'Setorial' | 'Apex / Research';
export interface Evento {
  id: string;
  nome: string;
  dataInicio?: string;
  dataFim?: string;
  local?: string;
  familia?: FamiliaEvento;
  status?: StatusEvento;
  descricao?: string;
  inscricoesAbertas?: boolean;
  solicitantesIds?: string[];
  cupomCvent?: string;
  linkCvent?: string;
  conviteUrl?: string;
  tipoEvento?: TipoEvento;
  /** v2 — Polo (UF) do evento. Fallback: derivado de `local` (ver ufDoEvento). */
  uf?: string;
}

/** v2 — Episódio do Programa Mundo Business (Temporada → Episódio). Só MB. */
export interface Episodio {
  id: string;
  titulo: string;
  temporada?: string;        // legado — texto solto
  temporadaId?: string;      // v2 — link para Temporada (modelo playlist)
  numero?: string;
  dataExibicao?: string;
  status?: string;
}

/** v2 — Temporada de um programa (modelo playlist). Programa é texto livre. */
export interface Temporada {
  id: string;
  temporada?: string;        // identificador legível, ex.: "Mundo Business · 13ª · 2026/2"
  programa?: string;         // livre: Mundo Business, Agro Business, etc.
  numero?: number;
  anoSemestre?: string;      // ex.: "2026/2"
  status?: 'atual' | 'planejada' | 'encerrada';
  qtdEpisodios?: number;
}

export type StatusInscricao = 'Inscrito' | 'Confirmado' | 'Cancelado' | 'Presente' | 'Interesse comercial';
export interface Inscricao {
  id: string;
  identificador?: string;
  eventoId?: string;
  pessoaId?: string;
  solicitanteId?: string;
  status?: StatusInscricao;
  dataInscricao?: string;
  observacoes?: string;
}


export interface DetalhesEvento {
  id: string;
  eventoId?: string;
  solicitanteId?: string;
  qtdConvidados?: number;
  perfilPublico?: string;
  temaCentral?: string;
  briefSpeech?: string;
  observacoesCliente?: string;
  urlGaleriaPosEvento?: string;
  nomeRepresentante?: string;
  cargoRepresentante?: string;
  produtoServicoDestacar?: string;
  participacaoPainel?: 'A definir' | 'Sim — confirmado' | 'Sim — em análise' | 'Não';
  materialArtesGraficas?: string;
  materialVideoInstitucional?: string;
  confirmacaoPalestrante?: string;
  subBlocosCustomizados?: string;
}

export type PendenciaTipo = 'Lista de convidados' | 'Brief' | 'Material/arquivo' | 'Info geral';
export type PendenciaStatus = 'Pendente' | 'Recebido' | 'Não se aplica';

export interface PendenciaCliente {
  id: string;
  identificador?: string;
  solicitanteId?: string;
  eventoId?: string;
  tipo?: PendenciaTipo;
  titulo?: string;
  descricao?: string;
  status?: PendenciaStatus;
  prazo?: string;
  respostaCliente?: string;
  anexoUrl?: string;
}

export type LembreteStatus = 'Pendente' | 'Concluído' | 'Cancelado';
export type LembretePrioridade = 'Baixa' | 'Média' | 'Alta';

// ====== ESCOPO DE ENTREGAS ======
export type FaseEscopo = 'Insights' | 'Pré-evento' | 'Durante o evento' | 'Pós-evento';
export type StatusEntrega = 'Pendente' | 'Em produção' | 'Aguardando aprovação' | 'Entregue' | 'Revisão solicitada';

export interface EntregaEscopo {
  id: string;
  contratoId: string;
  eventoSubtipo?: string;
  fase: FaseEscopo;
  entrega: string;
  quantidade: number;
  status: StatusEntrega;
  demandaId?: string;
  observacoes?: string;
}

/** Fases na ordem correta do fluxo de evento */
export const FASES_ESCOPO: FaseEscopo[] = ['Insights', 'Pré-evento', 'Durante o evento', 'Pós-evento'];

/** Template padrão de entregas por fase (referência SALTON 2026) */
export const TEMPLATE_ENTREGAS: Record<FaseEscopo, { entrega: string; qtdPadrao: number }[]> = {
  'Insights': [
    { entrega: 'Relatórios setoriais (e-mail)', qtdPadrao: 1 },
  ],
  'Pré-evento': [
    { entrega: 'Logomarca em convite digital', qtdPadrao: 1 },
    { entrega: 'Logomarca em formulário de inscrição', qtdPadrao: 1 },
    { entrega: 'Logomarca em redes sociais', qtdPadrao: 1 },
    { entrega: 'Logomarca em e-mail MKT', qtdPadrao: 1 },
    { entrega: 'Logomarca em vídeo teaser', qtdPadrao: 1 },
    { entrega: 'Logomarca em apresentações comerciais', qtdPadrao: 1 },
  ],
  'Durante o evento': [
    { entrega: 'Logomarca palco/materiais físicos', qtdPadrao: 1 },
    { entrega: 'Convites exclusivos', qtdPadrao: 5 },
    { entrega: 'Vídeo institucional 30s', qtdPadrao: 1 },
  ],
  'Pós-evento': [
    { entrega: 'Logomarca em aftermovie', qtdPadrao: 1 },
    { entrega: 'Logomarca em galeria de fotos', qtdPadrao: 1 },
    { entrega: 'Presença em relatórios de visibilidade', qtdPadrao: 1 },
  ],
};

// ====== ANOTAÇÕES ======
export type RecursoTipo = 'demanda' | 'contrato' | 'evento' | 'geral';

export interface Anotacao {
  id: string;
  texto: string;
  recursoTipo: RecursoTipo;
  recursoId: string;
  autorEmail: string;
  autorNome: string;
  criadoEm: string;
  editadoEm?: string;
  visivelCliente?: boolean;
}

// ====== AUDIT LOG ======
export interface UploadedFile {
  key: string;
  originalName: string;
  contentType: string;
  size: number;
  uploaded?: string;
  uploadedBy: string;
  uploadedByName: string;
  demandaId?: string;
  contratoId?: string;
  uploadedAt?: string;
  url?: string;
}

export interface AuditEntry {
  id: string;
  acao: string;
  usuario: string;
  email: string;
  papel: string;
  tipoRecurso: string;
  idRecurso: string;
  detalhes: string;
  data: string;
}

export interface Lembrete {
  id: string;
  titulo?: string;
  descricao?: string;
  criadorId?: string;
  solicitanteId?: string;
  demandaId?: string;
  prazo?: string;
  hora?: string;       // HH:MM (24h)
  status?: LembreteStatus;
  prioridade?: LembretePrioridade;
  avisarDiasAntes?: number;
  avisadoEm?: string;
}

// ====== MAC — Sprint 8 ======
export type CategoriaAtivacao =
  | 'Real Estate' | 'Áreas de Negócios' | 'Produtos da Gestora'
  | 'Research & Iscas' | 'Teses' | 'Serviços' | 'Institucional';
export type StatusAtivacao = 'ativa' | 'a_criar';
export type TipoLocal = 'fisico' | 'digital';
export type StatusOferta = 'ativo' | 'em_estruturacao' | 'encerrado';

export interface AtivacaoMAC {
  id: string;
  nome: string;
  categoria: CategoriaAtivacao;
  descricao?: string;
  landingPageUrl?: string;
  videoUrl?: string;
  status: StatusAtivacao;
  salesforceCampo?: string;
  /** S3 — frente/time dono da ativação (valida LP/material). */
  frenteDona?: string;
  /** Aprovação: quem confirmou a ativação (a_criar → ativa) e quando. */
  aprovadaPor?: string;
  aprovadaEm?: string;
}

export interface LocalAtivacao {
  id: string;
  nome: string;
  descricao?: string;
  tipo: TipoLocal;
  /** S3 — time que verifica este canal (link Áreas). */
  timeVerificadorId?: string;
}

export interface PlanejamentoEventoMAC {
  id: string;
  eventoId: string;
  ativacaoIds: string[];
  localIds: string[];
  notasEstrategicas?: string;
  /** S3 — rascunho até "Confirmar planejamento". */
  status?: 'rascunho' | 'confirmado';
  dataConfirmacao?: string;
  /** S3 — itens ativação×canal (embutidos no GET/PUT). */
  itens?: PlanejamentoItemMAC[];
}

/** S3 — item de planejamento MAC: canais definidos por ativação. */
export interface PlanejamentoItemMAC {
  id: string;
  planejamentoId: string;
  ativacaoId: string;
  canalIds: string[];
  statusVerificacao: 'pendente' | 'em_verificacao' | 'ok';
  cardsGeradosIds?: string[];
}

export interface OfertaMAC {
  id: string;
  nome: string;
  areaUnidade?: string;
  status: StatusOferta;
  dataReserva?: string;
  dataLiquidacao?: string;
  produto?: string;
  rentabilidade?: string;
  descricao?: string;
}

// ====== EXECUÇÃO DE EVENTO — Sprint 9 ======
export interface ExecucaoCardInfo {
  id: string;
  titulo: string;
  status: string;
  executorNome: string | null;
  subItems: { total: number; pendente: number; em_producao: number; concluido: number };
  checklist: { total: number; concluidos: number };
}
export interface ExecucaoAreaProgress {
  areaId: string;
  areaNome: string;
  cards: ExecucaoCardInfo[];
  totalSubItems: number;
  concluidoSubItems: number;
  percentual: number;
}
export interface ExecucaoEvento {
  eventoId: string;
  eventoNome: string;
  status: string;
  totalCards: number;
  porArea: ExecucaoAreaProgress[];
  progressoGeral: number;
}

/** Display de cliente: SEMPRE em caixa alta (padronização P38). */
export function clienteDisplay(nome?: string | null): string {
  if (!nome) return '—';
  return nome.toUpperCase();
}
